// Messages for the picker "Completed" guard (13 Oct 2026, request 2026-03189).
// Shared by PickerRequestView and TopUpPickerView.

import { formatMoney } from "../../services/pickerCostCheck";

// The task is no longer assigned to this account at the moment of the click:
// nothing is saved and the sales order is NOT released.
export const NOT_YOUR_TASK_MSG =
  "Not completed — this order is no longer assigned to you, so nothing was saved. " +
  "Go back to the Pickers Task List and assign it to yourself first.";

// The order was released but the task update matched no rows (it changed hands in
// the moment between the check and the save).
export const TASK_NOT_CLOSED_MSG =
  "The order was released, but your task could not be closed (it may have been " +
  "reassigned). Please ask a supervisor to check the Pickers Task List.";

// Helper text under the items while Completed is disabled (PickerRequestView only).
export const COMPLETE_GATE_MSG =
  "Enter the actual cost (different from the estimate) and the order number for every " +
  "item to enable Completed.";

// The cost typed for a line equals its estimate, so the gate can't tell it was
// confirmed (26 Oct 2026). Wording only — the gate rule itself is unchanged: the
// picker adds one cent and the price is corrected to the actual amount in Unleashed.
export function costEqualsEstimateMsg(label, estimate) {
  const est = Number(estimate);
  const plusCent = Math.round(est * 100 + 1) / 100;
  return (
    `${label}: the cost you entered (${formatMoney(est)}) matches the estimate. ` +
    `If that is the real cost, add one cent (${formatMoney(plusCent)}) so the order can be ` +
    "completed — the price will be corrected to the actual amount in Unleashed as usual."
  );
}
